import React, { useEffect, useRef, useState } from 'react';

import AdyenCheckout from '@adyen/adyen-web';
import '@adyen/adyen-web/dist/adyen.css';
import * as api from 'services/api';
import Spinner from '../spinner/Spinner';
import { config } from 'config/config';
import getConfig from 'next/config';

const { ADYEN_ENVIRONMENT, ADYEN_CLIENT_KEY } = config.APP;

export const PaymentCheckout = ({
  onPaymentCompleted,
  onError,
  session,
  config,
  newCheckout,
  checkoutData,
  setPaymentStep,
  setBrandCard,
  setCardNumber,
  loader,
  setLoader,
}) => {
  const { DEFAULT_LANGUAGE } = getConfig().publicRuntimeConfig;
  const paymentContainer = useRef(null);
  const dropin = useRef(null);
  useEffect(() => {
    if (!session || !paymentContainer.current) {
      // initiateCheckout is not finished yet.
      return;
    }
    createCheckout();
  }, [session, config, onPaymentCompleted, onError, api]);

  const createCheckout = async () => {
    const onFieldValid = (brand) => {
      if (brand?.encryptedFieldName === 'encryptedCardNumber') {
        setCardNumber(brand.endDigits);
        setBrandCard(brand.type);
      }
    };

    const cardConfiguration = {
      hasHolderName: true,
      holderNameRequired: true,
      showStoredPaymentMethods: false,
      enableStoreDetails: false,
      showBrandsUnderCardNumber: false,
      positionHolderNameOnTop: true,
      showBrandIcon: false,
      onFieldValid,
    };
    const translations = {
      'es-ES': {
        'creditCard.holderName.placeholder': '',
        'creditCard.numberField.title': 'Número de la tarjeta',
        'creditCard.expiryDateField.title': 'Validez MM/AA',
        'creditCard.cvcField.title': 'CVC',
        'creditCard.cvcField.placeholder.4digits': '',
        'creditCard.cvcField.placeholder.3digits': '',
        'creditCard.expiryDateField.placeholder': '',
        'creditCard.numberField.placeholder': '',
      },
    };

    const configuration = {
      environment: ADYEN_ENVIRONMENT,
      clientKey: ADYEN_CLIENT_KEY,
      analytics: { enabled: false },
      session,
      paymentMethodsResponse: { paymentMethods: config },
      translations: translations,
      onSubmit: async (state) => {
        // setLoader(true);
        dropin.current.setStatus('loading');
        // send to api to make the payment
        try {
          const data = {
            isValid: state.isValid,
            data: state.data,
            session: session,
            checkoutData: checkoutData,
          };
          const { data: response } = await api.processAdyenCheckout(data);
          // if the result has action handle it
          if (response?.paymentResponse?.action) {
            setLoader(false);
            dropin.current.handleAction(response?.paymentResponse?.action);
          } else {
            onPaymentCompleted(response);
          }
        } catch (err) {
          setPaymentStep('pay-error');
          setLoader(false);
          onPaymentCompleted({ resultCode: 'Error' });
        }
      },
      onPaymentCompleted: (result) => {
        onPaymentCompleted(result);
      },
      onAdditionalDetails: async (state) => {
        try {
          setLoader(true);
          const {
            data: { message, userResourceCallback },
          } = await api.waitingAdyenCheckout({
            threeDSResult: state.data.details.threeDSResult,
            checkoutId: newCheckout.BSTKD,
            checkoutData: checkoutData,
          });
          if (
            [
              'Authorised',
              'Pending',
              'AuthenticationFinished',
              'AuthenticationNotRequired',
              'Received',
            ].includes(message)
          ) {
            const response = {
              paymentResponse: { resultCode: 'Success' },
              userResourceCallback,
            };
            onPaymentCompleted(response);
            setLoader(false);
          } else {
            onError();
            setLoader(false);
          }
        } catch (err) {
          onError();
        }
      },
      onError,
      locale: DEFAULT_LANGUAGE,
      paymentMethodsConfiguration: {
        card: cardConfiguration,
        threeDS2: {
          challengeWindowSize: '05',
        },
      },
    };

    let checkout;
    try {
      checkout = await AdyenCheckout(configuration);
    } catch (err) {
      setPaymentStep('pay-error');
    }

    if (paymentContainer.current) {
      dropin.current = checkout
        .create('dropin')
        .mount(paymentContainer.current || '#liww-con-adyen-dropin');
    }
  };

  return (
    <div className="w-full payment-container">
      {loader && (
        <div className="regular-body checkout-payment-spinner">
          <Spinner />
        </div>
      )}
      <div
        ref={paymentContainer}
        id="liww-con-adyen-dropin"
        className={`checkout-payment-gateway__${
          loader ? 'hidden' : 'visible'
        } w-full`}></div>
    </div>
  );
};
